import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AppProvider } from './context/AppContext';
import { FocusProvider } from './context/FocusContext';
import PageViewTracker from './components/analytics/PageViewTracker';
import LandingPage from './pages/LandingPage';
import FocusPage from './pages/FocusPage';
import FlashesPage from './pages/FlashesPage';
import GoalsPage from './pages/GoalsPage';
import AnalyticsPage from './pages/AnalyticsPage';
import CommunityPage from './pages/CommunityPage';
import FionaPage from './pages/FionaPage';
import SettingsPage from './pages/SettingsPage';
import './App.css';

function App() {
  return (
    <div className="App">
      <Router>
        <PageViewTracker />
        <AppProvider>
          <FocusProvider>
            <Routes>
              {/* Landing Page */}
              <Route path="/" element={<LandingPage />} />
              
              {/* App Routes */}
              <Route path="/app" element={<Navigate to="/app/focus" replace />} />
              <Route path="/app/focus" element={<FocusPage />} />
              <Route path="/app/flashes" element={<FlashesPage />} />
              <Route path="/app/goals" element={<GoalsPage />} />
              <Route path="/app/analytics" element={<AnalyticsPage />} />
              <Route path="/app/community" element={<CommunityPage />} />
              <Route path="/app/fiona" element={<FionaPage />} />
              <Route path="/app/settings" element={<SettingsPage />} />
              
              {/* Fallback */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </FocusProvider>
        </AppProvider>
      </Router>
    </div>
  );
}

export default App;
